export default {
	title: "Orixás",
	name: "Nombre",
	color: "Color",
	create: "Nuevo Orixá",
	edit: "Editar Orixá",
	confirmDeleteMessage: "¿Está seguro de que desea eliminar el orixá {name}? Las personas vinculadas tendrán el campo vacío.",
	searchPlaceholder: "Buscar orixá...",
	noData: "Ningún orixá registrado",
	stats: {
		total: "Total",
	},
	messages: {
		createSuccess: "Orixá creado con éxito",
		updateSuccess: "Orixá actualizado con éxito",
		deleteSuccess: "Orixá eliminado con éxito",
		createError: "Error al crear orixá",
		updateError: "Error al actualizar orixá",
		deleteError: "Error al eliminar orixá",
		loadError: "Error al cargar orixás",
	},
	validation: {
		nameRequired: "El nombre es obligatorio",
		nameMaxLength: "El nombre debe tener como máximo 100 caracteres",
	},
};
